import { create, defaulted, Describe, nullable, optional, string, type } from 'superstruct';

import { MediaGalleryConfig } from '~modules/media-gallery/model/Config';

export const MediaGalleryConfigValidator: Describe<Required<MediaGalleryConfig>> = defaulted(
  type({
    realm: optional(nullable(string())),
    query: optional(nullable(string())),
  }),
  {
    realm: '',
    query: '',
  },
);

export default (rawConfig: string): MediaGalleryConfig => {
  let config: Partial<MediaGalleryConfig>;
  try {
    config = JSON.parse(rawConfig);
  } catch (_error) {
    config = {};
  }

  return create(config, MediaGalleryConfigValidator);
};
